import { render, staticRenderFns } from "./EditCustomerPortalBrandingForm.vue?vue&type=template&id=47c02634&"
import script from "./EditCustomerPortalBrandingForm.vue?vue&type=script&lang=ts&"
export * from "./EditCustomerPortalBrandingForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports